import { render, staticRenderFns } from "./OnboardingBackdocCamera.vue?vue&type=template&id=5a98721e"
import script from "./OnboardingBackdocCamera.vue?vue&type=script&lang=js"
export * from "./OnboardingBackdocCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports